<section class="navigation section-box">
  <app-section-menu
    [menuItems]="{
      'Technical Initial Access': 'technical-initial-access',
      'Post Exploitation': 'post-exploitation',
      'Technical Impact': 'technical-impact',
      'Non-Technical Impact': 'non-technical-impact',
    }"
  />
</section>

<section class="rims section-box" id="rims">
  <article class="rims-primary-details">
    <div class="section-header">
      <div class="section-header-title-section">
        <h1 class="title h1-medium">RIMS (Raven Incident Modeling Standard)</h1>
      </div>
      <p>
        RIMS (Raven Incident Modeling Standard) is a structured framework designed to systematically categorize and
        understand the complexities of cyber attacks. By transforming unstructured data—such as continuous text—into a
        structured format, RIMS enables more efficient data handling, comparison, and analysis. The standardized nature
        of RIMS facilitates consistent storage and processing of incident data, making it easier to identify patterns
        and correlations across different cases. Additionally, RIMS incorporates sequential information, allowing for
        the reconstruction of attack timelines and the detailed examination of each step in an incident.
      </p>
    </div>

    <div [ngClass]="{ 'rims-grid': true }">
      @for (rimsPhaseInfo of this.rimsPhaseInfos; track rimsPhaseInfo.name) {
        <section [id]="rimsPhaseInfo.name.toLowerCase().replaceAll(' ', '-')">
          <app-rims-phase-card [rimsPhaseInfo]="rimsPhaseInfo" />
        </section>
      }
    </div>
  </article>
</section>
